import { Sports } from '@gin-betting/constants';

export const availableIds = [
    Sports.ESPORTS_COUNTER_STRIKE,
    Sports.ESPORTS_DOTA_2,
    Sports.ESPORTS_VALORANT,
] as const;
